const WENDEZEIT = 'Dienstfahrt/Wendezt.';
const FAHREN = 'Fahren';

export default {
  /**
   * This function is called while looping through dutyActivities to create a list of duty activities whose activities
   * might merge several items. Each item can have child objects within the children attribute.
   *
   * shouldMergeDutyActivity must check what happens with the currentDutyActivity. However the function does not
   * manipulate data but needs to return an advice what should be done (described in return)
   *
   * @param {Object} MeinDienst module configuration object
   * @param {Object} accumulator The duty activity which may accumulate other duty activities
   * @param {Object} currentDutyActivity The current duty activity when looping through all activities
   * @param {Array} dutyActivities all duty activities
   * @param {Number} currentIndex the current index when looping through the duty activities
   * @returns string one of the following
   *                 new: that is the current item is used right away
   *                 mergeToAccumulator: the next two items are merged with the current item
   */
  shouldMergeDutyActivity: ({ moduleConfig, accumulator, currentDutyActivity, dutyActivities, currentIndex }) => {
    if (
      ['A', 'E'].includes(currentDutyActivity.activityShortname) &&
      currentDutyActivity.toMinutesAfterMidnight &&
      currentDutyActivity.fromMinutesAfterMidnight &&
      parseInt(currentDutyActivity.toMinutesAfterMidnight) <= parseInt(currentDutyActivity.fromMinutesAfterMidnight)
    ) {
      return 'ignore';
    }

    if (['PauHin', 'PauRück', 'UNBPAU', 'AblHin', 'AblRück', 'üWegZ'].includes(currentDutyActivity.activityShortname)) {
      return 'ignore';
    }

    if (!accumulator) {
      return 'mergeToAccumulator';
    }

    if (accumulator.blockcode === currentDutyActivity.blockcode || !currentDutyActivity.blockcode) {
      // as long as these conditions are met, the duty activity can be collapsed and thus merged to the accumulator
      // object which collects collapsible items within the children attribute
      return 'mergeToAccumulator';
    }

    return 'new'; // instruction to create a new accumulator, that is a new outer item (collapsible card) is created
  },
  /**
   * Returns the first relevant activity within the given dutyActivities array.
   * @param {Object} MeinDienst module configuration object
   * @param {Array} dutyActivities Array of sorted activities (by time) belonging to one duty
   * @returns dutyActivity declared to be the first relevant
   */
  getFirstActivity: ({ moduleConfig, dutyActivities }) => {
    return dutyActivities[0];
  },
  /**
   * Returns the last duty activity in the sorted list of duty activities.
   * Defaults to return the last activity within the array of activities
   *
   * LVB does not use the last item to determine the end time in some cases.
   * However, the logic is not clear.
   * It seems like LEIB, SANGAusfahrt are blacklisted as last activity within LVB.
   * @param {Object} MeinDienst module configuration object
   * @param {*} dutyActivities
   * @returns the last relevant duty activity
   */
  getLastActivity: ({ moduleConfig, dutyActivities }) => {
    return dutyActivities[dutyActivities.length - 1];
  },

  /**
   * Returns the track selection applied when the user chooses a duty activity.
   * Only set properties are getting used. Therefore the default case does not set the track property.
   * @param dutyActivity
   * @returns {{startToMinutesAfterMidnight, endToMinutesAfterMidnight, line,track, blockcode}}
   */
  getTrackSpecificationFromDutyActivity: (dutyActivity) => {
    return {
      track: dutyActivity.blockcode,
      line: dutyActivity.line,
      blockcode: dutyActivity.blockcode,
      startToMinutesAfterMidnight: dutyActivity.fromMinutesAfterMidnight,
      endToMinutesAfterMidnight: dutyActivity.toMinutesAfterMidnight,
    };
  },

  /**
   * Pre process the duty activities to apply some filters or sorting
   * @param moduleConfig
   * @param dutyActivities
   * @returns dutyActivities
   */
  preProcessDutyActivities: (moduleConfig, dutyActivities) => {
    /*
    // OP-11951
    dutyActivities = dutyActivities.map((activity, i) => {
      if (!activity.blockcode) {
        // get the next valid blockcode as set the blockcode
        for (let x = i; x < dutyActivities.length; x++) {
          if (dutyActivities[x] && dutyActivities[x].blockcode) {
            activity.blockcode = dutyActivities[x].blockcode;
            break;
          }
        }
      }
      return activity;
    });
    */
    return dutyActivities.sort((a, b) => a.sort - b.sort);
  },
};
